import React, { Component } from 'react';

export class PickSummaryView extends Component {

    constructor(props) {
        super(props);
        this.getBinInfo = this.getBinInfo.bind(this);
        this.createPickingSummaryTable = this.createPickingSummaryTable.bind(this);
        this.createAdditionalInfoTable = this.createAdditionalInfoTable.bind(this);
    }

    getBinInfo(inventoryDetailArray, editModeActive, updatePickSummaryQtyFunction) {
        var binInfo;
        if (inventoryDetailArray.length > 0) {
            binInfo = (
                <table>
                    <thead>
                        <tr>
                            <td>Bin</td>
                            <td>Qty</td>
                        </tr>
                    </thead>
                    <tbody>
                        {inventoryDetailArray.map(function (bin, idx) {
                            return (
                                <tr key={idx}>
                                    <td>{bin.bin}</td>
                                    <td><input value={bin.qty} onChange={(e) => {updatePickSummaryQtyFunction(e, bin.lineUniqueId, bin.bin) }} disabled={!editModeActive}></input></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            )
        } else {
            binInfo = 'N/A'
        }
        return binInfo;
    }

    createPickingSummaryTable(itemsPicked, editModeActive) {
        var updatePickSummaryQtyFunction = this.props.updatePickSummaryQty;
        var updateCancelledFunction = this.props.updateCancelled;
        var updateBackorderedFunction = this.props.updateBackordered;
        var getBinInfoFunction = this.getBinInfo;
        return (
            <table className='PickingSummaryItems'>
                <thead>
                    <tr>
                        <td>Item</td>
                        <td>Qty</td>
                        <td>Inventory Detail</td>
                        <td>Qty Cancelled</td>
                        <td>Backordered</td>
                    </tr>
                </thead>
                <tbody>
                    {itemsPicked.map(function (item, idx) {
                        if(!item.bin) {
                            item.bin = 'N/A';
                        }
                        return (
                            <tr key={idx}>
                                <td>{item.item}</td>
                                <td><input value={item.qty} onChange={(e) => { updatePickSummaryQtyFunction(e, item.lineUniqueId, item.bine) }} disabled={!editModeActive || item.inventoryDetailArray.length > 0}></input></td>
                                <td>{getBinInfoFunction(item.inventoryDetailArray, editModeActive, updatePickSummaryQtyFunction)}</td>
                                <td><input type="checkbox" checked={item.cancelRemaining} onChange={(e) => { updateCancelledFunction(e, item.lineUniqueId) }} disabled={!editModeActive || item.cancelledItemsProcessed}></input></td>
                                <td><input type="checkbox" checked={item.isBackordered} onChange={(e) => { updateBackorderedFunction(e, item.lineUniqueId) }} disabled={!editModeActive}></input></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }

    createAdditionalInfoTable(additionalInfo, itemsPicked, editModeActive) {
        var editAdditionalInfoFieldFunction = this.props.editAdditionalInfoField;
        for (var i in additionalInfo) {
            var lineUniqueId = additionalInfo[i].lineUniqueId;
            for (var j in itemsPicked) {
                if (itemsPicked[j].lineUniqueId == lineUniqueId) {
                    additionalInfo[i].item = itemsPicked[j].item;
                    break;
                }
            }
        }
        return (
            <table className='PickingSummaryItems'>
                <thead>
                    <tr>
                        <td>Item</td>
                        <td>Field</td>    
                        <td>Value</td>
                    </tr>
                </thead>
                <tbody>
                    {additionalInfo.map(function (infoItem, idx) {
                        return (
                            <tr key={idx}>
                                <td>{infoItem.item}</td>
                                <td>{infoItem.promptText}</td>
                                <td><input value={infoItem.value} onChange={(e) => { editAdditionalInfoFieldFunction(e, infoItem.fieldId, infoItem.lineUniqueId) }} disabled={!editModeActive}></input></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }



    render() {
        var pickingSummary = this.props.pickingSummary;
        var editModeActive = this.props.canEditSummary;
        return (
            <div>
                <hr className="rounded" />
                <h3>{pickingSummary.tranId}</h3>
                <h4>Currently Picked By - {pickingSummary.user}</h4>
                {
                    (pickingSummary.pickers && pickingSummary.pickers.length > 0) &&
                    <div>
                        <h3>Previously picked by</h3>
                        {pickingSummary.pickers.map(function (picker, idx) {
                            return (
                                <h4>{picker}</h4>
                            )
                        })}
                        <br />
                    </div>
                }
                <h4>Status - {pickingSummary.status}</h4>
                <h4>Message - {pickingSummary.message}</h4>
                <br />
                {
                    pickingSummary.fulfillments.length > 0 &&
                    <div>
                        <h3>Completed Fulfillments</h3>
                        {pickingSummary.fulfillments.map(function (fulfillment, idx) {
                            return (
                                <h4>{fulfillment}</h4>
                            )
                        })}
                        <br />
                    </div>
                }
                {
                    pickingSummary.bill && <h4>Bill: {pickingSummary.bill}</h4>
                }
                {
                    pickingSummary.itemsToBeProcessed.length > 0 &&
                    <div>
                        <h3>To Be Processed Pick</h3>
                        {this.createPickingSummaryTable(pickingSummary.itemsToBeProcessed, editModeActive)}
                    </div>
                }
                {
                    pickingSummary.processedItems.length > 0 && 
                    <div>
                        <h3>Processed Picks</h3>
                        {this.createPickingSummaryTable(pickingSummary.processedItems,false)}
                    </div>
                }
                {
                    pickingSummary.additionalInfo && pickingSummary.additionalInfo.length > 0 &&
                    <div>
                        <h3>Additional Info</h3>
                        {this.createAdditionalInfoTable(pickingSummary.additionalInfo, pickingSummary.itemsToBeProcessed, editModeActive)}
                    </div>
                }
                {
                    pickingSummary.processedAdditionalInfo && pickingSummary.processedAdditionalInfo.length > 0 &&
                    <div>
                        <h3>Processed Additional Info</h3>
                        {this.createAdditionalInfoTable(pickingSummary.processedAdditionalInfo, pickingSummary.processedItems, false)}
                    </div>
                }

                
                <br />
                <div className="submitButtons">
                    <button onClick={() => this.props.resetState()}>Back</button>
                        {editModeActive && <button onClick={() => this.props.submitPickingSummaryEdit()}>Submit</button>}
                    </div>
            </div>
        );
    }
}